export default "__VITE_ASSET__ARfxqq$e__"